<div class="house-navigation">
    <button
        class="navigate-btn"
        type="button"
        (click)="onBack()"
        aria-label="Go back"
    >
        <i class="fas fa-arrow-left" aria-hidden="true"></i>
    </button>
    <h2 class="house-name">
        {{ houseData?.farmHouseName || '-' }}
    </h2>
</div>
<div class="insights-panel">
    <!-- Tab Navigation -->
    <div class="tab-navigation">
        <button
            *ngFor="let tab of tabs"
            class="tab-button"
            [class.active]="isActiveTab(tab.id)"
            (click)="setActiveTab(tab.id)"
        >
            {{ tab.label }}
        </button>
    </div>

    <!-- Tab Content -->
    <div class="tile-content">
        <!-- Global No Data State -->
        <div *ngIf="!loading && !houseData" class="text-center py-4">
            <div class="alert alert-warning">
                <h4>No data available</h4>
                <p>Unable to load data for this house.</p>
            </div>
        </div>

        <!-- General Overview Tab -->
        <div
            *ngIf="!loading && houseData && isActiveTab('overview')"
            class="tab-pane"
        >
            <div class="inventory-parent">
                <!-- Live Sensors Widget -->
                <app-house-details-widget>
                    <div widget-title>
                        <img
                            src="/assets/img/dashboard-farm-overview/presentation.svg"
                            class="title-icon me-2"
                            alt="Live Sensors"
                        />
                        Live Sensors (Averages)
                    </div>

                    <!-- Sensor Grid when data is available -->
                    <div
                        *ngIf="houseData?.liveSensors && hasSensorData()"
                        class="sensor-grid"
                    >
                        <div>
                            <img
                                src="/assets/img/notification-icons/temperature.svg"
                                class="inline-icon me-1"
                                alt="Temperature"
                            />
                            {{
                                formatToTwoDecimalPlaces(
                                    houseData?.liveSensors?.temperature
                                )
                            }}
                            °C
                        </div>
                        <div>
                            <img
                                src="/assets/img/dashboard-farm-overview/humidity-icon.svg"
                                class="inline-icon me-1"
                                alt="Humidity"
                            />
                            {{
                                formatToTwoDecimalPlaces(
                                    houseData?.liveSensors?.humidity
                                )
                            }}%
                        </div>
                        <div>
                            <img
                                src="/assets/img/dashboard-farm-overview/co2-icon.svg"
                                class="inline-icon me-1"
                                alt="CO2"
                            />
                            {{
                                formatToTwoDecimalPlaces(
                                    houseData?.liveSensors?.cO2
                                )
                            }}
                            ppm
                        </div>
                        <div>
                            <img
                                src="/assets/img/dashboard-farm-overview/scale.svg"
                                class="inline-icon me-1"
                                alt="Weight"
                            />
                            {{
                                formatToTwoDecimalPlaces(
                                    houseData?.liveSensors?.weight
                                )
                            }}
                            g
                        </div>
                        <!-- <div>
                            <img
                                src="/assets/img/dashboard-farm-overview/eye-icon.svg"
                                class="inline-icon me-1"
                                alt="Light Intensity"
                            />
                            {{
                                formatToTwoDecimalPlaces(
                                    houseData?.liveSensors?.lightIntensity
                                )
                            }}
                            lux
                        </div> -->
                        <div>
                            <img
                                src="/assets/img/notification-icons/water.svg"
                                class="inline-icon me-1"
                                alt="Water Flow"
                            />
                            {{
                                formatToTwoDecimalPlaces(
                                    houseData?.liveSensors?.waterFlow
                                )
                            }}
                            L/h
                        </div>
                    </div>

                    <div
                        *ngIf="!houseData?.liveSensors || !hasSensorData()"
                        class="empty-sensor-message"
                    >
                        <i class="fas fa-exclamation-circle"></i>
                        <p>No sensor data available</p>
                    </div>
                </app-house-details-widget>

                <!-- Cycle Progress Widget -->
                <app-house-details-widget>
                    <div widget-title>
                        <img
                            src="/assets/img/dashboard-farm-overview/cycle.svg"
                            class="title-icon me-2"
                            alt="Cycle Progress"
                        />
                        Cycle Progress
                    </div>
                    <div>
                        <div
                            class="d-flex justify-content-between align-items-center mb-1"
                        >
                            <span>Weight Progress</span>
                            <span>{{ weightProgress || '-' }}%</span>
                        </div>
                        <p-progressBar
                            [showValue]="false"
                            [mode]="'determinate'"
                            [value]="weightProgress || 0"
                        ></p-progressBar>
                        <div class="d-flex justify-content-between mt-2">
                            <div>
                                <div class="text-muted small">Current</div>
                                <div class="fw-bold">
                                    {{
                                        houseData?.weightProgress
                                            ?.currentWeight || '-'
                                    }}
                                    g
                                </div>
                            </div>
                            <div class="text-end">
                                <div class="text-muted small">Target</div>
                                <div class="fw-bold">
                                    {{
                                        houseData?.weightProgress
                                            ?.targetWeight || '-'
                                    }}
                                    g
                                </div>
                            </div>
                        </div>
                    </div>
                </app-house-details-widget>

                <!-- Batch Summary Widget -->
                <app-house-details-widget>
                    <div widget-title>
                        <img
                            src="/assets/img/dashboard-farm-overview/scale.svg"
                            class="title-icon me-2"
                            alt="Batch Summary"
                        />
                        Batch Summary
                    </div>
                    <div class="row g-2">
                        <div class="col-6">
                            <div class="text-muted small">Birds</div>
                            <div class="fw-bold">
                                {{
                                    (houseData?.batchSummary?.birdCount
                                        | number) || '-'
                                }}
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="text-muted small">Age</div>
                            <div class="fw-bold">
                                {{
                                    houseData?.batchSummary?.birdAgeInDays ||
                                        '-'
                                }}
                                days
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="text-muted small">Feed Consumption</div>
                            <div class="fw-bold">
                                {{
                                    houseData?.batchSummary
                                        ?.feedConsumptionRate + ' KG' || '-'
                                }}
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="text-muted small">Phase</div>
                            <div class="fw-bold">Active</div>
                        </div>
                    </div>
                </app-house-details-widget>
            </div>

            <!-- Environmental Sensors Section -->
            <h2 class="section-title mt-3">Environmental Sensors</h2>
            <div *ngIf="!loading && houseData" class="inventory-parent">
                <!-- Temperature -->
                <app-house-details-widget>
                    <div widget-title class="sensor-widget-title">
                        <img
                            src="/assets/img/notification-icons/temperature.svg"
                            class="title-icon-left"
                            alt="Temperature"
                        />
                        <span class="sensor-title-text">Temperature</span>
                        <div
                            *ngIf="getTemperatureSensors().length > 0"
                            widget-badge
                            [class]="
                                'status-pill ' +
                                getStatusClass(
                                    getTemperatureSensors().length > 0
                                        ? getTemperatureSensors()[0].value
                                        : 0,
                                    20,
                                    30
                                )
                            "
                        >
                            {{
                                getStatusClass(
                                    getTemperatureSensors()[0]?.value || 0,
                                    20,
                                    30
                                ) === 'status-normal'
                                    ? 'Normal'
                                    : getStatusClass(
                                            getTemperatureSensors()[0]?.value ||
                                                0,
                                            20,
                                            30
                                        ) === 'status-warning'
                                      ? 'Warning'
                                      : 'Critical'
                            }}
                        </div>
                    </div>
                    <button
                        *ngIf="getTemperatureSensors().length > 3"
                        class="expand-btn-below"
                        type="button"
                        (click)="toggleExpand('temp')"
                    >
                        {{ isExpanded('temp') ? 'Collapse' : 'Expand' }}
                    </button>
                    <div
                        *ngIf="getTemperatureSensors().length > 0"
                        class="sensor-list"
                        [class.expanded]="isExpanded('temp')"
                    >
                        <div
                            class="sensor-row"
                            *ngFor="
                                let s of isExpanded('temp')
                                    ? getTemperatureSensors()
                                    : getTemperatureSensors().slice(0, 3)
                            "
                        >
                            <span class="sensor-name">{{ s.sensorLabel }}</span>
                            <span class="sensor-value"
                                >{{
                                    formatToTwoDecimalPlaces(s.value)
                                }}
                                °C</span
                            >
                        </div>
                        <div class="subtext">Optimal: 20-30 °C</div>
                    </div>

                    <div
                        *ngIf="getTemperatureSensors().length === 0"
                        class="empty-sensor-message"
                    >
                        <i class="fas fa-exclamation-circle"></i>
                        <p>No temperature sensors available</p>
                    </div>
                </app-house-details-widget>

                <!-- Humidity -->
                <app-house-details-widget>
                    <div widget-title class="sensor-widget-title">
                        <img
                            src="/assets/img/dashboard-farm-overview/humidity-icon.svg"
                            class="title-icon-left"
                            alt="Humidity"
                        />
                        <span class="sensor-title-text">Humidity</span>
                        <div
                            *ngIf="getHumiditySensors().length > 0"
                            widget-badge
                            [class]="
                                'status-pill ' +
                                getStatusClass(
                                    getHumiditySensors().length > 0
                                        ? getHumiditySensors()[0].value
                                        : 0,
                                    55,
                                    65
                                )
                            "
                        >
                            {{
                                getStatusClass(
                                    getHumiditySensors()[0]?.value || 0,
                                    55,
                                    65
                                ) === 'status-normal'
                                    ? 'Normal'
                                    : getStatusClass(
                                            getHumiditySensors()[0]?.value || 0,
                                            55,
                                            65
                                        ) === 'status-warning'
                                      ? 'Warning'
                                      : 'Critical'
                            }}
                        </div>
                    </div>
                    <button
                        *ngIf="getHumiditySensors().length > 3"
                        class="expand-btn-below"
                        type="button"
                        (click)="toggleExpand('humidity')"
                    >
                        {{ isExpanded('humidity') ? 'Collapse' : 'Expand' }}
                    </button>
                    <div
                        *ngIf="getHumiditySensors().length > 0"
                        class="sensor-list"
                        [class.expanded]="isExpanded('humidity')"
                    >
                        <div
                            class="sensor-row"
                            *ngFor="
                                let s of isExpanded('humidity')
                                    ? getHumiditySensors()
                                    : getHumiditySensors().slice(0, 3)
                            "
                        >
                            <span class="sensor-name">{{ s.sensorLabel }}</span>
                            <span class="sensor-value"
                                >{{ formatToTwoDecimalPlaces(s.value) }}%</span
                            >
                        </div>
                        <div class="subtext">Optimal: 55-65%</div>
                    </div>

                    <div
                        *ngIf="getHumiditySensors().length === 0"
                        class="empty-sensor-message"
                    >
                        <i class="fas fa-exclamation-circle"></i>
                        <p>No humidity sensors available</p>
                    </div>
                </app-house-details-widget>

                <!-- CO2 -->
                <app-house-details-widget>
                    <div widget-title class="sensor-widget-title">
                        <img
                            src="/assets/img/dashboard-farm-overview/co2-icon.svg"
                            class="title-icon-left"
                            alt="CO2"
                        />
                        <span class="sensor-title-text">CO2</span>
                        <div
                            *ngIf="getCO2Sensors().length > 0"
                            widget-badge
                            [class]="
                                'status-pill ' +
                                getStatusClass(
                                    getCO2Sensors().length > 0
                                        ? getCO2Sensors()[0].value
                                        : 0,
                                    0,
                                    3000
                                )
                            "
                        >
                            {{
                                getStatusClass(
                                    getCO2Sensors().length > 0
                                        ? getCO2Sensors()[0].value
                                        : 0,
                                    0,
                                    3000
                                ) === 'status-normal'
                                    ? 'Normal'
                                    : getStatusClass(
                                            getCO2Sensors().length > 0
                                                ? getCO2Sensors()[0].value
                                                : 0,
                                            0,
                                            3000
                                        ) === 'status-warning'
                                      ? 'Warning'
                                      : 'Critical'
                            }}
                        </div>
                    </div>
                    <button
                        *ngIf="getCO2Sensors().length > 3"
                        class="expand-btn-below"
                        type="button"
                        (click)="toggleExpand('co2')"
                    >
                        {{ isExpanded('co2') ? 'Collapse' : 'Expand' }}
                    </button>
                    <div
                        *ngIf="getCO2Sensors().length > 0"
                        class="sensor-list"
                        [class.expanded]="isExpanded('co2')"
                    >
                        <div
                            class="sensor-row"
                            *ngFor="
                                let s of isExpanded('co2')
                                    ? getCO2Sensors()
                                    : getCO2Sensors().slice(0, 3)
                            "
                        >
                            <span class="sensor-name">{{ s.sensorLabel }}</span>
                            <span class="sensor-value"
                                >{{
                                    formatToTwoDecimalPlaces(s.value)
                                }}
                                ppm</span
                            >
                        </div>
                        <div class="subtext">Optimal: &lt;3000 ppm</div>
                    </div>

                    <div
                        *ngIf="getCO2Sensors().length === 0"
                        class="empty-sensor-message"
                    >
                        <i class="fas fa-exclamation-circle"></i>
                        <p>No CO2 sensors available</p>
                    </div>
                </app-house-details-widget>

                <!-- Light Intensity -->
                <!-- <app-house-details-widget>
                    <div widget-title class="sensor-widget-title">
                        <img
                            src="/assets/img/dashboard-farm-overview/eye-icon.svg"
                            class="title-icon-left"
                            alt="Light Intensity"
                        />
                        <span class="sensor-title-text">Light Intensity</span>
                        <div
                            *ngIf="getLightIntensitySensors().length > 0"
                            widget-badge
                            [class]="
                                'status-pill ' +
                                getStatusClass(
                                    getLightIntensitySensors().length > 0
                                        ? getLightIntensitySensors()[0].value
                                        : 0,
                                    20,
                                    60
                                )
                            "
                        >
                            {{
                                getStatusClass(
                                    getLightIntensitySensors()[0]?.value || 0,
                                    20,
                                    60
                                ) === 'status-normal'
                                    ? 'Normal'
                                    : getStatusClass(
                                            getLightIntensitySensors()[0]
                                                ?.value || 0,
                                            20,
                                            60
                                        ) === 'status-warning'
                                      ? 'Warning'
                                      : 'Critical'
                            }}
                        </div>
                    </div>
                    <button
                        *ngIf="getLightIntensitySensors().length > 3"
                        class="expand-btn-below"
                        type="button"
                        (click)="toggleExpand('light')"
                    >
                        {{ isExpanded('light') ? 'Collapse' : 'Expand' }}
                    </button>
                    <div
                        *ngIf="getLightIntensitySensors().length > 0"
                        class="sensor-list"
                        [class.expanded]="isExpanded('light')"
                    >
                        <div
                            class="sensor-row"
                            *ngFor="
                                let s of isExpanded('light')
                                    ? getLightIntensitySensors()
                                    : getLightIntensitySensors().slice(0, 3)
                            "
                        >
                            <span class="sensor-name">{{ s.sensorLabel }}</span>
                            <span class="sensor-value"
                                >{{
                                    formatToTwoDecimalPlaces(s.value)
                                }}
                                lux</span
                            >
                        </div>
                        <div class="subtext">Optimal: 20-60 lux</div>
                    </div>

                    <div
                        *ngIf="getLightIntensitySensors().length === 0"
                        class="empty-sensor-message"
                    >
                        <i class="fas fa-exclamation-circle"></i>
                        <p>No light intensity sensors available</p>
                    </div>
                </app-house-details-widget> -->
            </div>

            <!-- Weight & Flow Monitoring Section -->
            <h2 class="section-title mt-3">Weight &amp; Flow Monitoring</h2>
            <div class="inventory-parent">
                <!-- Water Flow -->
                <app-house-details-widget>
                    <div
                        widget-title
                        class="sensor-widget-title water-flow-title"
                    >
                        <div class="water-flow-title-left">
                            <img
                                src="/assets/img/notification-icons/water.svg"
                                class="title-icon-left"
                                alt="Water Flow"
                            />
                            <span class="sensor-title-text">Water Flow</span>
                        </div>
                        <span
                            *ngIf="getWaterFlowSensors().length > 0"
                            class="water-interval-badge"
                        >
                            Day:
                            {{
                                formatToTwoDecimalPlaces(
                                    getWaterFlowSensors()[0]?.dailyWater
                                )
                            }}L | Cycle:
                            {{
                                formatToTwoDecimalPlaces(
                                    getWaterFlowSensors()[0]?.cycleWater
                                )
                            }}L
                        </span>
                    </div>
                    <button
                        *ngIf="getWaterFlowSensors().length > 3"
                        class="expand-btn-below"
                        type="button"
                        (click)="toggleExpand('water')"
                    >
                        {{ isExpanded('water') ? 'Collapse' : 'Expand' }}
                    </button>
                    <div
                        *ngIf="getWaterFlowSensors().length > 0"
                        class="sensor-list"
                        [class.expanded]="isExpanded('water')"
                    >
                        <div
                            class="sensor-row water-flow-sensor-row"
                            *ngFor="
                                let s of isExpanded('water')
                                    ? getWaterFlowSensors()
                                    : getWaterFlowSensors().slice(0, 3)
                            "
                        >
                            <div class="water-sensor-header">
                                <span class="water-sensor-name">{{
                                    s.sensorLabel
                                }}</span>
                                <span class="water-sensor-value"
                                    >{{
                                        formatToTwoDecimalPlaces(s.value)
                                    }}
                                    L/h</span
                                >
                            </div>
                        </div>
                        <div class="subtext">Optimal: 10-30 L/h</div>
                    </div>

                    <div
                        *ngIf="getWaterFlowSensors().length === 0"
                        class="empty-sensor-message"
                    >
                        <i class="fas fa-exclamation-circle"></i>
                        <p>No water flow sensors available</p>
                    </div>
                </app-house-details-widget>

                <!-- Weight Sensor -->
                <app-house-details-widget>
                    <div widget-title class="sensor-widget-title">
                        <img
                            src="/assets/img/dashboard-farm-overview/scale.svg"
                            class="title-icon-left"
                            alt="Weight Sensor"
                        />
                        <span class="sensor-title-text">Weight Sensor</span>
                    </div>
                    <div>
                        <div class="value">
                            {{
                                formatToTwoDecimalPlaces(
                                    houseData?.flowMonitoring?.weight
                                )
                            }}
                            g
                        </div>
                        <div class="subtext">Current Batch</div>
                        <div
                            class="d-flex justify-content-between align-items-center mt-2"
                        >
                            <span class="subtext">Growth Progress</span>
                            <span class="subtext"
                                >{{ weightProgress || 0 }}%</span
                            >
                        </div>
                        <p-progressBar
                            [showValue]="false"
                            [mode]="'determinate'"
                            [value]="weightProgress || 0"
                        ></p-progressBar>
                    </div>
                </app-house-details-widget>

                <!--  Feed Consumption -->
                <app-house-details-widget>
                    <div widget-title class="sensor-widget-title">
                        <img
                            src="/assets/img/dashboard-farm-overview/scale.svg"
                            class="title-icon-left"
                            alt="Feed Consumption"
                        />
                        <span class="sensor-title-text">Feed Consumption</span>
                    </div>
                    <div>
                        <div class="value">
                            {{
                                formatToTwoDecimalPlaces(
                                    houseData?.flowMonitoring
                                        ?.feedConsumptionRate
                                )
                            }}
                            kg
                        </div>
                        <div class="subtext">Total Weight</div>
                    </div>
                </app-house-details-widget>
            </div>
            <div class="ai-disclaimer">
                <i class="fas fa-info-circle"></i>
                <p>
                    <strong>Note:</strong> AI model is still learning about your
                    environment to improve accuracy of the results
                </p>
            </div>
            <h2 class="section-title">Camera Monitoring System</h2>
            <div *ngIf="!loading && houseData" class="camera-grid">
                <!-- Dynamic Camera Cards based on camera details -->
                <app-house-details-widget
                    *ngFor="let camera of cameraDetails; let i = index"
                >
                    <div widget-title class="camera-title">
                        <div class="camera-title-row">
                            <span class="camera-name">{{ camera.name }}</span>
                            <span
                                *ngIf="camera.status"
                                class="status-pill"
                                [ngClass]="getCameraStatusClass(camera.status)"
                                >{{ camera.status }}</span
                            >
                        </div>
                        <!-- <div class="camera-area">{{ camera.area }}</div> -->
                    </div>
                    <div>
                        <div
                            class="snapshot-box"
                            (click)="openLightbox(i)"
                            style="cursor: pointer"
                        >
                            <img
                                [src]="camera.imageUrl"
                                class="snapshot-icon"
                                alt="Camera"
                                [style.width]="'100%'"
                                [style.height]="'100%'"
                                (error)="
                                    $event.target.src =
                                        '/assets/img/notification-icons/camera.svg'
                                "
                            />
                        </div>
                        <div class="meta small">
                            Last snapshot: {{ camera.lastSnapshot }}
                        </div>
                        <div class="metrics-column">
                            <div class="metric">
                                <b>Bird Count:</b>
                                <span class="subtext">{{
                                    camera.birdsCount
                                }}</span>
                            </div>
                            <div class="metric">
                                <b>Mortality AI Analysis:</b>
                                <span class="subtext">{{
                                    camera.mortalityAIAnalysis
                                }}</span>
                            </div>
                            <div class="metric">
                                <b>Movement Patterns:</b>
                                <span class="subtext">{{
                                    camera.movementPatterns
                                }}</span>
                            </div>
                        </div>
                    </div>
                </app-house-details-widget>

                <!-- Fallback if no camera details -->
                <div
                    *ngIf="
                        !cameraLoading &&
                        (!cameraDetails || cameraDetails.length === 0)
                    "
                    class="text-center py-4"
                >
                    <p class="text-muted">No camera data available</p>
                </div>

                <!-- Loading state for camera details -->
                <div *ngIf="cameraLoading" class="text-center py-4">
                    <p class="text-muted">Loading camera details...</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div
    *ngIf="lightboxOpen && currentCamera"
    class="camera-lightbox"
    (click)="closeLightbox()"
>
    <div class="lightbox-content" (click)="$event.stopPropagation()">
        <button
            class="lightbox-close"
            (click)="closeLightbox()"
            aria-label="Close lightbox"
        >
            <i class="fas fa-times"></i>
        </button>

        <button
            *ngIf="cameraDetails.length > 1"
            class="lightbox-nav lightbox-nav-prev"
            (click)="navigateLightbox('prev')"
            aria-label="Previous camera"
        >
            <i class="fas fa-chevron-left"></i>
        </button>

        <button
            *ngIf="cameraDetails.length > 1"
            class="lightbox-nav lightbox-nav-next"
            (click)="navigateLightbox('next')"
            aria-label="Next camera"
        >
            <i class="fas fa-chevron-right"></i>
        </button>

        <div class="lightbox-image-container">
            <img
                [src]="currentCamera.imageUrl"
                [alt]="currentCamera.name"
                class="lightbox-image"
                (error)="
                    $event.target.src =
                        '/assets/img/notification-icons/camera.svg'
                "
            />
        </div>

        <div class="lightbox-info">
            <div class="lightbox-header">
                <h3 class="lightbox-title">{{ currentCamera.name }}</h3>
                <span
                    *ngIf="currentCamera.status"
                    class="status-pill"
                    [ngClass]="getCameraStatusClass(currentCamera.status)"
                    >{{ currentCamera.status }}</span
                >
            </div>
            <div class="lightbox-meta">
                <span>Last snapshot: {{ currentCamera.lastSnapshot }}</span>
                <span class="lightbox-counter"
                    >{{ currentCameraIndex + 1 }} /
                    {{ cameraDetails.length }}</span
                >
            </div>
            <div class="lightbox-metrics">
                <div class="lightbox-metric">
                    <b>Bird Count:</b>
                    <span>{{ currentCamera.birdsCount }}</span>
                </div>
                <div class="lightbox-metric">
                    <b>Mortality AI Analysis:</b>
                    <span>{{ currentCamera.mortalityAIAnalysis }}</span>
                </div>
                <div class="lightbox-metric">
                    <b>Movement Patterns:</b>
                    <span>{{ currentCamera.movementPatterns }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
